import { render, staticRenderFns } from "./Shipcode.vue?vue&type=template&id=3627fb64&"
import script from "./Shipcode.vue?vue&type=script&lang=js&"
export * from "./Shipcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports